import { useState } from 'react'

import mainStyles from 'assets/css/main.module.scss'

import Accordion from './accordion/Accordion'
import Menu from './menu/Menu'
const FaqSection = () => {
  const [activeItem, setActiveItem] = useState('general information')
  const [, setTitle] = useState('general information')
  return (
    <div className="tour-nma-faq w-full pb-[67px] pt-[80px]">
      <div className="w-[782px] m-[0_auto_68px_auto]">
        <h2 className={mainStyles.bigTitle}>Everything You Need to Know</h2>
      </div>
      <div className="flex gap-12 w-[1120px] mx-auto">
        <Menu setActiveItem={setActiveItem} setTitle={setTitle} />
        <Accordion activeItem={activeItem} />
      </div>
    </div>
  )
}

export default FaqSection
